import React from "react";
import FreshBooksStyles from "./FreshBooks.styles";
const FreshBooksInstruction = () => {
    return (
        <>
            <div style={FreshBooksStyles.container}>
                <div style={FreshBooksStyles.instructionCard}>
                    <strong style={FreshBooksStyles.strong}>INSTRUCTIONS : </strong>
                    <ul style={FreshBooksStyles.ul}>
                        <li style={FreshBooksStyles.li}><span style={FreshBooksStyles.bullet}>•</span>FreshBook Connect button will prompt you to enter your FreshBook Log In info.</li>
                        <li style={FreshBooksStyles.li}><span style={FreshBooksStyles.bullet}>•</span>We will import payer, payee and 1099 amounts from FreshBook to Tax1099.com system.</li>
                        <li style={FreshBooksStyles.li}><span style={FreshBooksStyles.bullet}>•</span>Make sure to verify data after import, correct any missing data then click on Finish to complete data import.</li>
                        <li style={FreshBooksStyles.li}><span style={FreshBooksStyles.bullet}>•</span>Accountant/User with multiple companies may import one company at a time. Once you finish data import for one company you will click again on FreshBook Connect button to initiate second company and so on.</li>
                        <li style={FreshBooksStyles.li}><span style={FreshBooksStyles.bullet}>•</span>All imported data will be efile ready for IRS/State and can be submitted under My Dashboard - Submit My Forms.</li>
                    </ul>
                </div>
            </div>
        </>
    );
};
export default FreshBooksInstruction